import { render, staticRenderFns } from "./companyIndex.vue?vue&type=template&id=4def4b67&scoped=true&"
import script from "./companyIndex.js?vue&type=script&lang=js&"
export * from "./companyIndex.js?vue&type=script&lang=js&"
import style0 from "./companyIndex.vue?vue&type=style&index=0&id=4def4b67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4def4b67",
  null
  
)

export default component.exports